import { PortalUrls } from '@servicetitan/cp-ui';

type Keys = 'list' | 'item';

export const JobsUrlMap: Record<Keys, string> = {
    list: PortalUrls.jobs.root,
    item: PortalUrls.jobs.root + PortalUrls.jobs.item,
};
